import * as firebase from "firebase/app";
import "firebase/auth";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBctNXEEednx0sHGA67K3WQtQuSqyKxkGE",
    authDomain: "phishy-277717.firebaseapp.com",
    databaseURL: "https://phishy-277717.firebaseio.com",
    projectId: "phishy-277717",
    storageBucket: "phishy-277717.appspot.com",
    messagingSenderId: "897894816961",
    appId: "1:897894816961:web:36c20b8e69ef8b8fb2c840",
    measurementId: "G-LGLV0Y1L4M",
    clientId: "897894816961-v2mhc06e43r07gjtmnmeg0o2rbg0emgi.apps.googleusercontent.com",
    scopes: ["https://www.googleapis.com/auth/gmail.modify"],
    discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest"]
});

export default firebaseApp;